const AvatarActionType = {
    FETCH_ALL_AVATARS: "ALL_AVATARS",
    FETCH_SINGLE_AVATAR: "FETCH_SINGLE_AVATAR",
  };
  export default AvatarActionType;
  